export default __webpack_public_path__ + "static/media/image6.ee81a541.jpg";